import React, { useState, useEffect } from "react";
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import PrimaryButton from './PrimaryButton';
import Grid from "@material-ui/core/Grid";
import CloseIcon from "../icons/CloseIcon";
import AddedIcon from "../icons/AddedIcon";
import Typography from "@material-ui/core/Typography";
import CustomInput from './CustomInput';
import translate from '../other/translate.json';
import config from '../other/config';
const { serverAPI } = config;

export default function AbortRecall(props) {
  let lang = localStorage.getItem('language') || 'Ru'
  const classes = useStyles();
  const {isAuth, usname} = props;
  // const [state, setState] = React.useState(false);
  const [authFio, _authFio] = useState(props.usname?.usname);
  const [authBank, _authBank] = useState(props.usname?.organization);
  const [authPosition, _authPosition] = useState(props.usname?.title);
  const [authMobile, _authMobile] = useState(props.usname?.phone);
  const [authMail, _authMail] = useState(props.usname?.email);
  const [usrfio, setUsrFio] = useState('');
  const [usrBank, setUsrBank] = useState('');
  const [usrPosition, setUsrPosition] = useState('');
  const [usrMobile, setUsrMobile] = useState('');
  const [usrMail, setUsrMail] = useState('');
  const [usrText, setText] = useState('');
  const [answer, setAnswer] = useState('');
  const [pdn, _pdn] = useState(false);

  let { ModalCallback, setModalCallback, appID, prodID } = props

  useEffect(() => {
    // if (props.isAuth == true) {
    let didCancel = false;
    async function fetchData() {
      const login = usname;
      if (!didCancel) {
        console.log("arc-auth",login)
        if (isAuth && login ) {

          _authFio(login.usname);
          _authBank(login.organization);
          _authPosition(login.title);
          _authMobile(login.phone);
          _authMail(login.email);
          setUsrFio(login.usname)
          setUsrBank(login.organization)
          setUsrPosition(login.title)
          setUsrMobile(login.phone)
          setUsrMail(login.email)
        }
      }
    }

    fetchData();

    return () => {
      didCancel = true;
    };
    // }
  }, [isAuth]);

  function toggleDrawer(open, event) {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
  };

  function closeDrawer() {
    setModalCallback(false)
    setAnswer('')
  }

  function cutFioValue(value) {
    const shouldSetValue = value.length < 256

    if (shouldSetValue) setUsrFio(value.replace(/ +/g, ' '))
  }

  function cutMailValue(value) {
    const shouldSetValue = value.length < 255

    if (shouldSetValue) setUsrMail(value.replace(/ +/g, ' '))
  }

  function cutBankValue(value) {
    const shouldSetValue = value.length < 256

    if (shouldSetValue) setUsrBank(value.replace(/ +/g, ' '))
  }

  function cutPositionValue(value) {
    const shouldSetValue = value.length < 256

    if (shouldSetValue) setUsrPosition(value.replace(/ +/g, ' '))
  }

  function cutMobileValue(value) {
    const shouldSetValue = value.length < 51

    if (shouldSetValue) setUsrMobile(value.replace(/ +/g, ' '))
  }

  function cutLetterValue(value) {
    const shouldSetValue = value.length < 256

    if (shouldSetValue) setText(value.replace(/ +/g, ' '))
  }

  async function sendmail() {
    let app = appID;
    let product = prodID;
    let fio = usrfio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/) ? usrfio.trim() : '';
    let bank = usrBank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? usrBank.trim() : ''
    let position = usrPosition.trim();
    let mail = usrMail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? usrMail.trim() : '';
    let phone = usrMobile.trim();
    let text = usrText;

    if (fio !== '' && phone !== '' && bank !== '') {
      const sendmail_res = await axios.post(`${serverAPI}/back_call`,
        { app, product, person: { fio, bank, position, mail, phone }, text, link: window.location.pathname }
      )

      setAnswer(sendmail_res.data.result)
    }
  }

  function list(anchor) {
    return (
      <div
        className={classes.list}
        role="presentation"
        onClick={() => toggleDrawer(anchor, false)}
        onKeyDown={() => toggleDrawer(anchor, false)}
        style={{ overflowX: 'hidden', overflowY: 'auto', scrollbarWidth: 'thin' }}
      >
        <Grid
          container
          direction="column"
          justify="flex-start"
          className={classes.root}
        >
          <Grid item container>
            <Grid className={classes.btnClose}>
              <IconButton onClick={() => closeDrawer()} aria-label="filter" className={classes.btnFilter}>
                <CloseIcon fill='#BCBBD0' />
              </IconButton>
            </Grid>

            <Grid item style={{ marginTop: 14 }}>
              <Typography className={classes.listHeader}>{translate.Words[`RequestCall_${lang}`]}</Typography>
            </Grid>
          </Grid>

          <Grid item container direction="column" style={{ marginTop: 29 }}>
            <Grid item>
              <form className={classes.rootForm} noValidate>
                <Grid container direction="column">
                  <Grid item>
                    <CustomInput
                      disabled={authFio?.length > 1}
                      error={usrfio.trim() === '' || usrfio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/) ? false : true}
                      valid={usrfio.trim() !== '' && usrfio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/) ? true : false}
                      helperText={usrfio === '' ? translate.Discuss[`MandatoryField${lang}`] : usrfio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/) ? translate.Discuss[`MandatoryField${lang}`] : translate.Discuss[`EnterTheCorrectData${lang}`]}
                      value={usrfio}
                      onChange={(e) => cutFioValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`LetterFullNamen_${lang}`]}
                      hint={true}
                    />
                  </Grid>

                  <Grid item>
                    <CustomInput
                      disabled={authMobile?.length > 1}
                      error={usrMobile?.trim() === '' || usrMobile?.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? false : true}
                      valid={usrMobile?.trim().length >= 3 && usrMobile?.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? true : false}
                      helperText={usrMobile === '' ? translate.Discuss[`MandatoryField${lang}`] : usrMobile?.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? translate.Discuss[`MandatoryField${lang}`] : translate.Discuss[`EnterTheCorrectData${lang}`]}
                      value={usrMobile}
                      onChange={(e) => cutMobileValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`ContactPhone${lang}`]}
                      hint={true}
                    />
                  </Grid>

                  <Grid item>
                    <CustomInput
                      disabled={authBank?.length > 1}
                      error={usrBank.trim() === '' || usrBank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? false : true}
                      valid={usrBank.trim() !== '' && usrBank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? true : false}
                      helperText={usrBank === '' ? translate.Discuss[`MandatoryField${lang}`] : usrBank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? translate.Discuss[`MandatoryField${lang}`] : translate.Discuss[`EnterTheCorrectData${lang}`]}
                      value={usrBank}
                      onChange={(e) => cutBankValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`Company${lang}`]}
                      hint={true}
                    />
                  </Grid>

                  <Grid item>
                    <CustomInput
                      disabled={authMail?.length > 1}
                      error={usrMail.trim() === '' || usrMail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? false : true}
                      valid={usrMail.trim() !== '' && usrMail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? true : false}
                      helperText={usrMail === '' ? translate.Discuss[`MandatoryField${lang}`] : usrMail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? translate.Discuss[`MandatoryField${lang}`] : translate.Discuss[`EnterTheCorrectEmail${lang}`]}
                      value={usrMail}
                      onChange={(e) => cutMailValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`Email${lang}`]}
                    // hint={true}
                    />
                  </Grid>

                  <Grid item>
                    <CustomInput
                      disabled={authPosition?.length > 1}
                      value={usrPosition}
                      onChange={(e) => cutPositionValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`Position${lang}`]}
                    />
                  </Grid>

                  <Grid item>
                    <CustomInput
                      value={usrText}
                      onChange={(e) => cutLetterValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`TypeYourTextHere${lang}`]}
                    />
                  </Grid>
                </Grid>
              </form>
            </Grid>

            <Grid item container direction="row" alignItems="center" className={classes.ActionArea}>
              <Grid item>
                <PrimaryButton
                  disabled={
                    (usrfio.trim() !== '' && usrfio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/))
                      &&
                      (usrMobile?.trim().length >= 3 && usrMobile?.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/))
                      &&
                      (usrBank.trim() !== '' && usrBank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/))
                      ?
                      false
                      :
                      true
                  }
                  height={55}
                  text={translate.Discuss[`Send_${lang}`]}
                  onClick={() => sendmail()}
                />
              </Grid>
            </Grid>

            <Grid item style={{ marginTop: 24 }}>

            </Grid>
          </Grid>
        </Grid>
      </div>
    )
  };

  function listSubmitTrue() {
    return (
      <div
        className={classes.list}
        role="presentation"
      >
        <Grid
          container
          direction="column"
          justify="center"
          className={classes.root}
          style={{ padding: 64, paddingTop: 254 }}
        >
          <Grid item container direction="column" justify="center" alignItems="center">
            <Grid className={classes.btnClose}>
              <IconButton onClick={() => closeDrawer()} aria-label="filter" className={classes.btnFilter}>
                <CloseIcon fill='#BCBBD0' />
              </IconButton>
            </Grid>

            <Grid item style={{ marginTop: 30 }}>
              <Grid
                container
                justify="center"
                alignItems="center"
                style={{ width: 72, height: 72, backgroundColor: '#81D39D', borderRadius: '50%', boxShadow: 'none' }}
              >
                <AddedIcon fill={'#FFFFFF'} />
              </Grid>
            </Grid>

            <Grid item style={{ marginTop: 30 }}>
              <Typography className={classes.listHeader} style={{ textAlign: 'center' }}>{translate.Discuss[`YouRequest${lang}`]}</Typography>
              <Typography className={classes.listHeader} style={{ textAlign: 'center' }}>{translate.Discuss[`Successfully${lang}`]}</Typography>
            </Grid>

            <Grid item style={{ marginTop: 40 }}>
              <PrimaryButton onClick={() => closeDrawer()} height={55} text={'Закрыть'} />
            </Grid>
          </Grid>
        </Grid>
      </div>)
  };

  function listSubmitFalse() {
    return (
      <div
        className={classes.list}
        role="presentation"
      >
        <Grid
          container
          direction="column"
          justify="center"
          className={classes.root}
          style={{ padding: 64, paddingTop: 254 }}
        >
          <Grid item container direction="column" justify="center" alignItems="center">
            <Grid className={classes.btnClose}>
              <IconButton onClick={() => closeDrawer()} aria-label="filter" className={classes.btnFilter}>
                <CloseIcon fill='#BCBBD0' />
              </IconButton>
            </Grid>

            <Grid item>
              <Grid
                container
                justify="center"
                alignItems="center"
                style={{ width: 72, height: 72, backgroundColor: '#BCBBD0', borderRadius: '50%', boxShadow: 'none' }}
              >
                <CloseIcon fill={'#FFFFFF'} />
              </Grid>
            </Grid>

            <Grid item style={{ marginTop: 30 }}>
              <Typography className={classes.listHeader} style={{ textAlign: 'center' }}>По техническим причинам</Typography>
              <Typography className={classes.listHeader} style={{ textAlign: 'center' }}>сервис временно недоступен.</Typography>
            </Grid>

            <Grid item style={{ marginTop: 24 }}>
              <Typography className={classes.Body1}>Попробуйте повторно позднее.</Typography>
            </Grid>

            <Grid item style={{ marginTop: 40 }}>
              <PrimaryButton onClick={() => closeDrawer()} height={55} text={'Закрыть'} />
            </Grid>
          </Grid>
        </Grid>
      </div>
    )
  };

  return (
    <div>
      <React.Fragment key="anchor">
        <Drawer
          anchor={"right"}
          open={ModalCallback}
          onClose={() => closeDrawer()}
        >
          <Grid className={classes.btnClose}>
            <IconButton onClick={() => closeDrawer()} aria-label="filter" className={classes.btnFilter}>
              <CloseIcon fill='#BCBBD0' />
            </IconButton>
          </Grid>

          <React.Fragment>
            {
              answer === 1
                ?
                listSubmitTrue('right')
                :
                answer === 0
                  ?
                  listSubmitFalse('right')
                  :
                  list()
            }
          </React.Fragment>
        </Drawer>
      </React.Fragment>
    </div>
  );

}

const useStyles = makeStyles(theme => ({
  root: {
    padding: 64,

    [theme.breakpoints.down(500)]: {
      padding: 24,
    },
  },

  list: {
    width: 600,

    [theme.breakpoints.down(696)]: {
      width: '100%',
    },
  },

  fullList: {
    width: 'auto',
  },

  listHeader: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '28px',
    lineHeight: '40px',
    color: "#24262A"
  },

  btnClose: {
    position: 'absolute',
    right: 12,
    top: 12,

    [theme.breakpoints.down(500)]: {
      zIndex: 1,
      borderRadius: '50%',
      backgroundColor: '#FFFFFF',
    }
  },

  Body1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2'
  },

  Info1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
    color: '#BCBBD0'
  },

  Caption1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '13px',
    lineHeight: '28px',
    display: 'flex',
    alignItems: 'center',
  },

  LinkType11: {
    color: 'inherit',
    textDecoration: 'none',
    borderBottom: '1px solid',
    borderColor: 'inherit',

    '&:hover': {
      color: '#2050FF',
      textDecoration: 'none',
      borderBottom: '1px solid #2050FF',
    }
  },

  ActionArea: {
    justifyContent: "space-between",
    marginTop: 11,
    maxWidth: 472,
  }
}));